let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("irpaz")).then(() => parcelRequire('4OBP7'));